import { useEffect, useRef } from 'react';
import './Loader.scss';

type IProps = {
  loader: string;
  imageSrc: string;
  isImage?: boolean;
};

const Loader = ({ loader, imageSrc, isImage = true }: IProps) => {
  const container = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const lottieInstance = (window as any).lottie;

    if (lottieInstance) {
      const animation = lottieInstance.loadAnimation({
        container: container.current!,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: loader,
      });

      return () => animation.destroy();
    }
  }, [loader]);

  return (
    <div className="loader-container">
      <div className="loader">
        {isImage && (
          <img
            src={imageSrc}
            alt="Front Image"
            className="front-image"
            width={100}
            height={100}
          />
        )}
        <div className="lottie-animation" ref={container}></div>
      </div>
    </div>
  );
};

export default Loader;
